import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  bgColor: {
    width: "100%",
    backgroundImage:
      "linear-gradient(90deg, rgba(83,109,254,1) 0%, rgba(0,113,188,1) 44%, rgba(27,20,100,1) 100%)",
    alignItems: "center",
  },
  container: {
    marginTop: theme.spacing(2),
    maxHeight: "100%",
    border: "2em",
  },
  media: {
    height: 200,
    borderRadius: "30px",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  card: {
    // height: "100%",
    minHeight: "100%",
    borderRadius: "30px",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    textAlign: "center",
  },
  bodytitle: {
    textAlign: "center",
    margin: theme.spacing(5),
  }
}));